import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Container, Loader } from "semantic-ui-react";
import TextAnswer from "../QuestionAnswerFragment/Layout";
import Editor from "../../components/Editor";
import {
	EditorState,
	convertToRaw,
	convertFromHTML,
	convertFromRaw,
	RawDraftContentState
} from "draft-js";
import {
	withStaticData,
	StaticDataProps
} from "../../helpers/StaticDataProvider";
import { firebaseDB, auth } from "../../firebase";
import NotLoggedInFallback from "../QuestionAnswerFragment/NotLoggedInFallback";

interface OverviewPageProps extends RouteComponentProps<{}>, StaticDataProps {
	infoKey: string;
}

interface State {
	editorState: EditorState;
}

class OverviewPage extends React.Component<OverviewPageProps, State> {
	state = {
		editorState: EditorState.createEmpty()
	};

	componentDidMount() {
		// TODO . Load from the DB
		const { infoKey } = this.props;
		firebaseDB
			.ref(`users/${auth.currentUser.uid}/summaries/${infoKey}`)
			.once("value", val => {
				const value = val.val();
				if (value) {
					this.setState({
						editorState: EditorState.createWithContent(
							convertFromRaw({
								entityMap: {},
								...(value ||
									({ blocks: {} } as RawDraftContentState))
							})
						)
					});
				}
			});
	}

	updateFirebase = () => {
		firebaseDB.ref(`users/${auth.currentUser.uid}/summaries`).update({
			[this.props.infoKey]: convertToRaw(
				this.state.editorState.getCurrentContent()
			)
		});
	};

	onEditorChange = newVal =>
		this.setState({ editorState: newVal }, this.updateFirebase);

	handleNext = () => {
		const currentSection = this.props.staticdata[this.props.infoKey];
		if (!currentSection) return;

		this.props.history.push(
			`/${this.props.infoKey}/${currentSection.quadrantOrder[0]}/answer`
		);
	};

	getText = () => {
		switch (this.props.infoKey) {
			case "owners":
				return "Owner's Profile";
			case "marketing":
				return "Marketing";
			case "strategy":
				return "Business Strategy";
			case "operations":
				return "Operations and Admin";
		}
	};

	render() {
		return (
			<Container text>
				<TextAnswer
					onBack={this.props.history.goBack}
					onNext={this.handleNext}
					goHome={() => {
						this.props.history.push("/" + this.props.infoKey);
					}}
					question={`If you’d like to complete your ${this.getText()} information here rather than individually for each component, or alternatively you could summarise what you’ve written in the components.`}
					title="Summary"
				>
					<Editor
						editorState={this.state.editorState}
						onEditorChange={this.onEditorChange}
					/>
				</TextAnswer>
			</Container>
		);
	}
}

const withUser = Wrapped =>
	class extends React.Component {
		state = {
			auth: null
		};
		componentDidMount() {
			auth.onAuthStateChanged(auth => {
				this.setState({ auth: auth });
			});
		}

		render() {
			return this.state.auth ? (
				<Wrapped {...this.props} />
			) : (
				<NotLoggedInFallback />
			);
		}
	};

export default withStaticData(withUser(OverviewPage));



// WEBPACK FOOTER //
// ./src/pages/OverviewPage/OverviewPage.tsx